<template>
  <ListLayout
    :title="`${configurationModule.warehouse}`"
    :tableData="warehouseList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    @getList="getWarehouseList"
    :context="context"
  >
    <template #listAction>
      <v-tooltip bottom :color="isButtonDisabled ? 'error' : ''">
        <template v-slot:activator="{ on: tooltip }">
          <div v-on="{ ...tooltip }">
            <PrimaryButton
              id="warehouseAdd"
              v-if="permissions && permissions.add"
              :disabled="isButtonDisabled"
              @click="$router.push({ name: 'add-warehouse' })"
              :name="`Add ${configurationModule.warehouse}`"
              icon="mdi-plus"
              iconSize="x-large"
            >
            </PrimaryButton>
          </div>
        </template>
        <span>{{ buttonTooltip }}</span>
      </v-tooltip>
    </template>
    <template #dialogs>
      <WarehouseLocation
        ref="warehouseLocation"
        v-model="openWarehouseLocationDialog"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import WarehouseButton from "@/components/Button/WarehouseButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import WarehouseLocation from "./WarehouseLocation.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: {
    WarehouseButton,
    ListLayout,
    WarehouseLocation,
  },
  data() {
    return {
      configurationModule,
      permissions: null,
      sorting: {},
      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,
      filters: {},
      warehouseList: [],
      headerSelected: [
        {
          headerName: "Warehouse Name",
          field: "name",
          sortable: true,
          pinned: "left",
          minWidth: 150,
        },
        {
          headerName: "Warehouse ID",
          field: "warehouse_id",
          sortable: true,
          pinned: "left",
          minWidth: 150,
        },
        {
          headerName: "branch",
          field: "branch",
          sortable: true,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: true,
          tooltipField: "address",
        },

        {
          headerName: "From Time",
          field: "from_time",
          sortable: true,
        },
        {
          headerName: "To Time",
          field: "to_time",
          sortable: true,
        },
      ],
      isEditing: false,
      showWarehouseForm: false,
      selectedWarehouseID: null,
      openWarehouseLocationDialog: false,

      isButtonDisabled: false,
      buttonTooltip: "Add Warehouses",
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 110,
          sortable: false,
          width: 110,
          cellRenderer: "WarehouseButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    checkSubscriptionLimit() {
      this.$api.company
        .checkSubscriptionLimit(this.profileObject.company, {
          module: "warehouse",
        })
        .then(() => {
          this.isButtonDisabled = false;
          return true;
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.data.non_field_errors[0],
            color: "error",
            timeout: 4000,
          });
          this.isButtonDisabled = true;
          this.buttonTooltip = err.data.non_field_errors[0];
          return false;
        });
    },
    openWarehouseLocation(id) {
      this.openWarehouseLocationDialog = true;
      let timer = setInterval(() => {
        if (this.$refs.warehouseLocation) {
          clearInterval(timer);
          this.$refs.warehouseLocation.getWarehouseDetails(id);
        }
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
      }, 10000);
    },
    getWarehouseList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.warehouse
        .getWarehouseList(params)
        .then((res) => {
          this.warehouseList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("configuration");

    this.checkSubscriptionLimit();
  },
};
</script>
